import React, { useState } from 'react';
import Modal from 'react-modal';
Modal.setAppElement('#root'); // Para accesibilidad del modal

const CrearHistoriaModal = ({ isOpen, onClose, servicios, onSave }) => {
    const [nombreHC, setNombreHC] = useState('');
    const [servicioLigado, setServicioLigado] = useState('');
    const [historiaClinica, setHistoriaClinica] = useState('');

    const handleSave = () => {
        const newHistoria = {
            nombreHC,
            servicioLigado,
            historiaClinica,
        };
        onSave(newHistoria);
        // Resetear los campos después de guardar
        setNombreHC('');
        setServicioLigado('');
        setHistoriaClinica('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="w-[60%] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
            overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[10]"
        >
            <h2 className="text-2xl text-left text-[#205087ff] font-bold mb-4">Crear historia clínica</h2>
            <div className="text-left grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="form-group">
                    <label className="form-label">Nombre de la Historia Clínica:</label>
                    <input
                        type="text"
                        required
                        value={nombreHC}
                        onChange={(e) => setNombreHC(e.target.value)}
                        className="form-input"
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">Servicio Ligado:</label>
                    <select
                        value={servicioLigado}
                        required
                        onChange={(e) => setServicioLigado(e.target.value)}
                        className="form-input"
                    >
                        <option value="" required>Selecciona una opcion</option>
                        {servicios.map((servicio) => (

                            <option key={servicio._id} value={servicio.service}>
                                {servicio.service}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label className="form-label">Historia Clínica:</label>
                    <select
                        value={historiaClinica}
                        required
                        onChange={(e) => setHistoriaClinica(e.target.value)}
                        className="form-input"
                    >
                        <option value="" required>Selecciona una opcion</option>
                        <option value="Opción 1">Opción 1</option>
                        <option value="Opción 2">Opción 2</option>
                        <option value="Opción 3">Opción 3</option>
                    </select>
                </div>
            </div>
            <div className="flex justify-end gap-3">
                <button
                    onClick={handleSave}
                    className="button-send"
                >
                    Guardar
                </button>
                <button
                    onClick={() => {
                        // Resetear los campos cuando se cancela
                        setNombreHC('');
                        setServicioLigado('');
                        setHistoriaClinica('');
                        onClose();
                    }}
                    className="button-gray"
                >
                    Cancelar
                </button>
            </div>
        </Modal>
    );
};

export default CrearHistoriaModal;
